/**
 * useArchiveHotspot / useUnarchiveHotspot — Issue #39
 *
 * useMutation gegen POST /api/v2/hotspots/:id/archive bzw. /unarchive.
 * Im Unterschied zu useRemoveHotspot (DELETE, entfernt die Zuordnung
 * komplett) bleibt der Besitz (owned) erhalten — nur active/archived_at
 * aendern sich. Gleiches Invalidierungs-Set wie useRemoveHotspot: die
 * Kontingent-Anzeige (Sidebar) haengt ebenfalls an ['dashboard'].
 */
import { useMutation, useQueryClient } from '@tanstack/react-query'
import apiClient from '../../lib/api-client'

function invalidateHotspotQueries(
  queryClient: ReturnType<typeof useQueryClient>,
  id: string | number,
) {
  void queryClient.invalidateQueries({ queryKey: ['hotspots'] })
  void queryClient.invalidateQueries({ queryKey: ['hotspot', String(id)] })
  void queryClient.invalidateQueries({ queryKey: ['dashboard'] })
}

export function useArchiveHotspot() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (id: string | number) => {
      const result = await apiClient.POST('/api/v2/hotspots/{id}/archive', {
        params: { path: { id: Number(id) } },
      })
      if (result.error) throw result.error
      return result.data
    },
    onSuccess: (_data, id) => invalidateHotspotQueries(queryClient, id),
  })
}

export function useUnarchiveHotspot() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (id: string | number) => {
      const result = await apiClient.POST('/api/v2/hotspots/{id}/unarchive', {
        params: { path: { id: Number(id) } },
      })
      // Quota-Absage (402) ist kein technischer Fehler, sondern ein erwartetes
      // Ergebnis (Aufrufer wertet ueber quotaInfoFromError aus) — dennoch
      // werfen, damit useMutation onError/catch greift statt still zu bleiben.
      if (result.error) throw result.error
      return result.data
    },
    onSuccess: (_data, id) => invalidateHotspotQueries(queryClient, id),
  })
}
